
const validate = (props) => {
    const errors = {}
    // if (!props.UserType) {
    //     errors.UserType = {
    //         ar: ' يرجى اختيار النوع  ',
    //         en: 'Please choose type'
    //     }
    // }
    if (!props.firstName) {
        errors.firstName = {
            ar: ' يرجى  ادخال الاسم الاول',
            en: 'Please enter first name'
        }
    }
    if (!props.lastName) {
        errors.lastName = {
            ar: ' يرجى  ادخال الاسم الاخير',
            en: 'Please enter last name'
        }
    }
    if (!props.email) {
        errors.email = {
            ar: 'يرجى ادخال البريد الالكتروني',
            en: 'Enter your email'
        }
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.email)) {
        errors.email = {
            ar: 'البريد الالكتروني غير صحيح',
            en: 'invalid email'
        }
    }
    // if (!props.StudentEmail) {
    //     errors.StudentEmail = {
    //         ar: 'يرجى ادخال البريد الالكتروني للطالب',
    //         en: 'Enter your email for student'
    //     }
    // } 
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.StudentEmail)) {
        errors.StudentEmail = {
            ar: 'البريد الالكتروني غير صحيح',
            en: 'invalid email'
        }
    }
    if (!props.UserName) {
        errors.UserName = {
            ar: ' يرجى  ادخال اسم المستخدم ',
            en: 'Please enter username'
        }
    }
    if (!props.password) {
        errors.password = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    }
    if (props.password && props.password.length < 8) {
        errors.password = {
            ar: ' كلمة المرور يجب ان تكون على الاقل 8حروف او ارقام',
            en: 'Password must be at least 8 digits'
        }
    }
    if (!props.confirmpassword) {
        errors.confirmpassword = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    }
    if (props.confirmpassword !== props.password) {
        errors.confirmpassword = {
            ar: 'كلمة المرور غير متطابقة',
            en: 'Password does not match'
        }
    }
    if (!props.address) {
        errors.address = {
            ar: ' يرجى  ادخال العنوان  ',
            en: 'Please enter the address'
        }
    }
    if (!props.phone) {
        errors.phone = {
            ar: ' يرجى  ادخال رقم الهاتف  ',
            en: 'Please enter the phone number'
        }
    }

    return errors
}

export default validate;